import { Injectable } from '@angular/core';
import { Cliente } from '../shared/model/ajustesUsuario/cliente.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Proyecto } from '../shared/model/gestion-proyectos/proyecto';
import { Base } from '../shared/model/core/base.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { Empleado } from '../shared/model/empleado/empleado.model';
import { Perfil } from '../shared/model/security/perfil.model';
import { Puesto } from '../shared/model/empleado/puesto.model';
import { Area } from '../shared/model/empleado/area.model';
import { Usuario } from '../shared/model/security/usuario.model';
import { Sitios } from '../shared/model/security/sitios.model';
import { ParametrosDTO } from '../shared/model/core/ParametrosDTO.model';
import { Historial } from '../shared/model/empleado/historial.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ParamReporteBean } from '../shared/model/tickets/paramreporte.model';
import { param } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class EmpleadoService {
  constructor(private httpClient: HttpClient) { }

  consultaCantidadEmpleados(reqEmpleado: ConsultaList<Empleado>) {
    return this.httpClient.post<Base>(UrlConstantes.consultaCantidadEmpleados, reqEmpleado);   //http://localhost:8081/CosSolser/controller/consultaNumEmpleados.do
  }
  consultaEmpleados(reqEmpleado: ConsultaList<Empleado>) {
    return this.httpClient.post<ConsultaList<Empleado>>(UrlConstantes.consultaEmpleados, reqEmpleado);  //http://localhost:8081/CosSolser/controllercontroller/consultaEmpleados.do
  }
  consultaEmpleadosActivos() {
    return this.httpClient.get<ConsultaList<Empleado>>(UrlConstantes.consultaEmpleadosActivos);
  }
  consultaEmpleadosPorPuesto(reqEmpleado: ConsultaList<Empleado>) {
    return this.httpClient.post<ConsultaList<Empleado>>(UrlConstantes.consultaEmpleadosPorPuesto, reqEmpleado);
  }

  guardaActualizaEmpleado(reqEmpleado: Empleado) {
    return this.httpClient.post<Base>(UrlConstantes.guardaActualizaEmpleado, reqEmpleado);
  }
  //actulizar estatus envio correo
  actualizaCorreoNotificacion(empleado: Empleado) {
    return this.httpClient.post<Base>(UrlConstantes.actualizaCorreoNotificacion, empleado);
  }

  actualizaStatusEmpleado(reqUsuario: Usuario) {
    return this.httpClient.post<Base>(UrlConstantes.actualizaStatusEmpleado, reqUsuario);
  }

  consultaPerfiles(nomSitio: Sitios) {
    return this.httpClient.post<ConsultaList<Perfil>>(UrlConstantes.consultaPerfiles, nomSitio);
  }
  consultaPerfilesEmpleado(idEmpleado: number) {
    return this.httpClient.post<ConsultaList<Perfil>>(UrlConstantes.consultaPerfilesEmpleado, idEmpleado);
  }
  consultaAreas() {
    return this.httpClient.post<ConsultaList<Area>>(UrlConstantes.consultaAreasEmpresa, "");
  }
  consultaPuestosArea(idArea: number) {
    return this.httpClient.post<ConsultaList<Puesto>>(UrlConstantes.consultaPuestosArea, idArea);
  }

  consultaAreaPuestoEmpleado() {
    return this.httpClient.get<Empleado>(UrlConstantes.consultaAreaPuestoEmpleado, {});
  }

  /**
   * Ojo: con una etapa de gestión de proyectos (id de Mongo) no sirve; ver
   * incidencias/etapa-incidencia.util.ts. Si el backend falla responde 200 sin
   * cuerpo, así que se entrega una lista vacía en vez de null.
   */
  consultaEmpleadosXEtapaPuesto(paramGen: ParametrosDTO) {
    return this.httpClient
      .post<Empleado[] | null>(UrlConstantes.consultaEmpleadosXEtapaPuesto, paramGen, {})
      .pipe(map((empleados) => empleados ?? []));
  }

  /// prueba de historial empleados............................


  consultaCantidadHistorial(reqHistorial: ConsultaList<Historial>) {
    return this.httpClient.post<Base>(UrlConstantes.consultaCantidadHistorial, reqHistorial);   //http://localhost:8081/CosSolser/controller/consultaNumHistorial.do
  }
  consultaEmpleadosHistorial(reqHistorial: ConsultaList<Historial>) {                          //http://localhost:8081/CosSolser/controller/consultaEmpleadosHistorial.do
    return this.httpClient.post<ConsultaList<Historial>>(UrlConstantes.consultaEmpleadosHistorial, reqHistorial);
  }
  
  consultaEmpleadosHistorialSolser(reqHistorial: ConsultaList<Historial>) {                          //http://localhost:8081/CosSolser/controller/consultaEmpleadosHistorial.do
    return this.httpClient.post<ConsultaList<Historial>>(UrlConstantes.consultaEmpleadosHistorialSolser, reqHistorial);
  }
  consultaCantidadHistorialSolser(reqHistorial: ConsultaList<Historial>) {
    return this.httpClient.post<Base>(UrlConstantes.consultaCantidadHistorialSolser, reqHistorial);   //http://localhost:8081/CosSolser/controller/consultaNumHistorial.do
  }

  descargarRegistro(reqHistorial: ConsultaList<Historial>) {
    return this.httpClient.post<Base>(UrlConstantes.registroHistorial, reqHistorial);
  }

  editarSalidaEntrada(reqEmpleado: Empleado | Historial) {
    return this.httpClient.post<Base>(UrlConstantes.EDITAR_SALIDA_ENTRADA, reqEmpleado);
  }

  agregarSalidaEntrada(reqEmpleado: any) {
    return this.httpClient.post<Base>(UrlConstantes.AGREGAR_SALIDA_ENTRADA, reqEmpleado);
  }
}
